///<reference path="./smart-mover.models.ts"/>
///<reference path="collection-model.ts"/>


module Meevo.Components.Controls.SmartMover {
    export class CollectionCategory<T> extends SmartMoverModel<T> implements ISmartMoverCategoryModel<T> {
        models: CollectionModel<any>[];

        public opened: boolean;

        get template(): string {
            return 'app/components/controls/smart-mover/views/category.html'
        }

        get isCategory() {
            return true;
        }

        get selected(): boolean {
            return this.models.some(row => row.selected);
        }

        set selected(value: boolean) {
            if (this.disabled) {
                return;
            }

            this.models.forEach(model => {
                model.selected = value;
            });
        }

        _disabled: boolean;
        get disabled(): boolean
        {
            return this._disabled;
        }

        set disabled(value: boolean)
        {
            this._disabled = value;
            this.models.forEach(model =>
            {
                model.disabled = value;
            });
        }

        get selectedModelsNumber(): number {
            return this.models.reduce((count, row) => {
                return row.selected ? count + 1 : count;
            }, 0);
        }

        get categoryCheckedClassName(): CategoryCheckboxClassName {
            if (this.models.length === 0) {
                return 'disabled';
            }

            const checkedSubCategoryLen: number = this.selectedModelsNumber;
            const subCategoryLen: number = this.models.length;

            if (checkedSubCategoryLen === 0) {
                return 'unchecked';
            }

            if (checkedSubCategoryLen === subCategoryLen) {
                return 'checked';
            }

            if (checkedSubCategoryLen > 0) {
                return 'partial';
            }

            return 'unchecked';
        }
        
        constructor(attributes: T, options: IModelOptions<T>) {
            super(attributes, options);


            this.models = [];
        }

        resetModels(value: CollectionModel<T>[] = []): void {
            this.models = value;
        }
    }
}